import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getQuotation(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createQuotation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/quotation" + pathname, body);
}

export async function updateQuotation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/quotation" + pathname, body);
}

export async function updateStatusQuotation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/quotation" + pathname, body);
}

export async function deleteQuotation(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/quotation" + pathname + queryParams);
}
